var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 0.599609C17.3246 0.599609 19.4003 2.70991 19.4004 5.34766V5.45215C19.4004 7.4913 18.1473 9.78909 16.4424 11.9189C14.7567 14.0248 12.7148 15.8608 11.3145 16.96C10.9426 17.2499 10.4811 17.4004 10 17.4004C9.51487 17.4004 9.05247 17.2523 8.68945 16.9639L8.68652 16.9619L8.13379 16.5156C6.78155 15.399 5.03318 13.7623 3.55762 11.9189C1.85274 9.78909 0.599609 7.4913 0.599609 5.45215V5.34766C0.599668 2.70991 2.67535 0.59961 5.19922 0.599609C6.66783 0.599609 8.05639 1.32529 8.92285 2.55859L8.92383 2.55957L9.50977 3.39062L10 4.08691L10.4902 3.39062L11.0762 2.55957L11.0771 2.55859C11.9436 1.32529 13.3322 0.599609 14.8008 0.599609Z",
    stroke: "#01152E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.f73448d79a3694102cd34a0e76d8532a.svg";
export { ForwardRef as ReactComponent };